$mol_dump_list $mol_view
	values /
	sub /
		<= Dump*0 $mol_dump_value
			value <= dump_value* null
			expanded? <=> dump_expanded*? false
			prototypes <= prototypes false
			preview_show <= preview_show true
